"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ITEM = void 0;
var ITEM;
(function (ITEM) {
    ITEM["MoneyPerBrick"] = "moneyPerBrick";
    ITEM["BricksPerClick"] = "bricksPerClick";
    ITEM["HouseSize"] = "houseSize";
    ITEM["Banker"] = "banker";
    ITEM["Bank"] = "bank";
    ITEM["Blueprint"] = "blueprint";
    ITEM["Hammer"] = "hammer";
    ITEM["Drone"] = "drone";
    ITEM["Builder"] = "builder";
    ITEM["Mixer"] = "mixer";
    ITEM["RoboticArm"] = "roboticArm";
    ITEM["Printer"] = "printer";
    ITEM["Crane"] = "crane";
    ITEM["Robot"] = "robot";
    ITEM["Ufo"] = "ufo";
})(ITEM = exports.ITEM || (exports.ITEM = {}));
